import paw from '@assets/paw.svg';
import type { CardItemBadge } from '@presentation/components';
import { CardItem } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { IoMdHeartDislike } from 'react-icons/io';
import { RiHeartAddFill } from 'react-icons/ri';
import { Footer } from './components/Footer';
import { Skeleton } from './components/Skeleton';
import * as Styled from './styled';
import type { CardItemLitterProps } from './types';

export * from './types';

export const CardItemLitter: FC<CardItemLitterProps> = (props) => {
  const {
    onClick,
    image,
    breed,
    breeder,
    location,
    price,
    futureLitter,
    isWishlisted = false,
    onWishlistClick,
    hasPedigreeFciBadge = false,
    hasPedigreeBadge = false,
    loading = false,
    link,
    lazyLoadImage = true,
    ...rest
  } = props;

  const { translate } = useTranslation();

  if (loading) return <Skeleton />;

  return (
    <CardItem
      lazyLoadImage={lazyLoadImage}
      link={link}
      image={image}
      onClick={onClick}
      imageButton={
        !!onWishlistClick && (
          <Styled.WishlistWrapper
            data-tooltip-content={translate(
              isWishlisted ? 'common.buttons.unfavorite' : 'common.buttons.favorite',
            )}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onWishlistClick?.(event);
            }}
          >
            {isWishlisted ? <IoMdHeartDislike /> : <RiHeartAddFill />}
          </Styled.WishlistWrapper>
        )
      }
      imageOverlay={
        !!futureLitter && (
          <>
            {translate('glossary.litterExpected')} {futureLitter.month} {futureLitter.year}
          </>
        )
      }
      badges={[
        ...(!hasPedigreeFciBadge
          ? []
          : [
              {
                label: translate('glossary.pedigreeFci'),
                image: paw,
                color: 'blue',
                expanded: true,
              } as CardItemBadge,
            ]),
        ...(!hasPedigreeBadge || hasPedigreeFciBadge
          ? []
          : [
              {
                label: translate('glossary.pedigree'),
                image: paw,
                color: 'blue',
                expanded: true,
              } as CardItemBadge,
            ]),
      ]}
      content={{
        title: breed,
        subtitle: !price ? undefined : (
          <>
            <Styled.PurpleSpan>{price}</Styled.PurpleSpan>
          </>
        ),
        text: location,
      }}
      footer={
        breeder ? (
          <>
            <Footer {...breeder} />
          </>
        ) : undefined
      }
      {...rest}
    />
  );
};
